import React from 'react';
import PropTypes from 'prop-types';

const Image = (props) => {
  return (
    <picture className={props.imgClassName}>
      <source
        media="(max-width: 768px)"
        srcSet={props.imgSmall}
      />
      <source
        media="(min-width: 768px)"
        srcSet={props.imgLarge}
      />
      <img
        alt={props.name}
        className="product-image"
        src={props.imgSmall}
      />
    </picture>
  )
};

Image.propTypes = {
  imgSmall: PropTypes.string,
  imgLarge: PropTypes.string,
  name: PropTypes.string,
  imgClassName: PropTypes.string,
};
export default Image;
